import { render } from "./UserInfosStep.vue?vue&type=template&id=8637c926&scoped=true"
import script from "./UserInfosStep.vue?vue&type=script&lang=ts"
export * from "./UserInfosStep.vue?vue&type=script&lang=ts"

import "./UserInfosStep.vue?vue&type=style&index=0&id=8637c926&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8637c926"

export default script